import React from "react";
import styles from "./MetaGrid.module.css";

export interface MetaGridProps {
  children: React.ReactNode;
}

const MetaGrid = ({ children }: MetaGridProps): React.ReactElement => {
  return <div className={styles.metaGrid}>{children}</div>;
};

export default MetaGrid;
